var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('botao-voltar',{attrs:{"text":"Voltar","route":this.$store.state.paciente.rotaOrigem}}),_c('container-component',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }